import React, { useEffect, useState } from 'react';
import { homeownerPost } from '../utils/homeownerApi';
import { HomeBuyerHistory } from './HomeTransferScreens';

export default function HomePreviousOwnerCard({ colors }) {
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (typeof homeownerPost !== 'function') return undefined;
    homeownerPost('/.netlify/functions/home-transfer', { action: 'history' })
      .then((data) => {
        if (!cancelled) setPayload(data || {});
      })
      .catch(() => {
        if (!cancelled) setPayload({ entries: [] });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const entries = payload && Array.isArray(payload.entries) ? payload.entries : [];
  if (!entries.length) return null;
  return (
    <div style={{ marginBottom: '1rem' }}>
      <HomeBuyerHistory
        colors={colors}
        note={payload.note}
        entries={entries}
      />
    </div>
  );
}
